import { QuestionAnswerBlock } from './ui/QuestionAnswerBlock.jsx'

export default QuestionAnswerBlock
